<template>
    <div class="content">
        <activity-board-search-history :services="services"></activity-board-search-history>
    </div>
</template>

<script>import script from './SearchHistory';
    export default script;</script>